import { Component, computed, inject } from '@angular/core';
import { AuthService } from '../../../services/auth.service';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { PrefixSubscriptionPipe, PrependDevUrlForEnvDevelopmentPipe, TranslatePipe } from '../../../../utils/pipes';
import { AvatarComponent } from '../../misc/avatar/avatar.component';
import { NgbPopover, NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule } from '@angular/common';
import { HelpersService } from '../../../services/helpers.service';

@Component({
    selector: 'app-admin-navigation',
    imports: [
        RouterModule,
        TranslatePipe,
        AvatarComponent,
        PrefixSubscriptionPipe,
        NgbPopover,
        CommonModule,
        NgbTooltip,
        PrependDevUrlForEnvDevelopmentPipe
    ],
    templateUrl: './admin-navigation.component.html',
    styleUrl: './admin-navigation.component.scss'
})
export class AdminNavigationComponent {
    authService = inject(AuthService);
    route = inject(ActivatedRoute);
    helpersService = inject(HelpersService);
    translatePipe = inject(TranslatePipe);
    user = this.authService.user;
    isAdminAssistantDetail = false;

    switchingToAccountId: number;

    studentsLabel = computed(() =>
        this.translatePipe.transform(`assistanttype_${this.user().assistantType ?? 'student'}`)
    );

    switchAccount($event: Event, id: number) {
        if (id === this.user().subscriptionId) {
            $event.preventDefault();
            return;
        }
        this.switchingToAccountId = id;
    }

    ngOnInit() {
        const backToAdminRef = this.route.snapshot.queryParams.ref;
        if (backToAdminRef) {
            localStorage.setItem('backToAdminRef', backToAdminRef);
            this.helpersService.removeParam('ref');
        }
        setTimeout(() => {
            if (document.querySelector('.app--admin app-partial-assistant-detail')) {
                this.isAdminAssistantDetail = true;
                document.querySelector('body').classList.remove('body--admin');
                setTimeout(() => {
                    const refLocalStorage = localStorage.getItem('backToAdminRef');
                    let replaceRef;
                    if (refLocalStorage !== 'null') {
                        replaceRef = refLocalStorage;
                    }
                    if (replaceRef) {
                        document
                            .querySelectorAll('a[data-replace-href-back-to-admin]')
                            .forEach((a) => ((a as HTMLAnchorElement).href = replaceRef));
                    }
                }, 1);
            }
        }, 1);
    }
}
